
        var result = require("!!../../../../node_modules/css-loader/index.js!./article.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/article.component.css
// module id = 2328
// module chunks = 1